const CONTENT_FACTORY_INTERNAL_TASK_MARKER = '[aeoll:content-factory-task]';

export const buildContentFactoryInternalTask = (lines: string[]): string =>
	[CONTENT_FACTORY_INTERNAL_TASK_MARKER, ...lines].join('\n');

export const isContentFactoryInternalTask = (value: unknown): boolean =>
	String(value ?? '')
		.trimStart()
		.startsWith(CONTENT_FACTORY_INTERNAL_TASK_MARKER);
